//@flow
import _ from 'lodash';
import * as React from 'react';
import { TableHeaderColumn } from 'react-bootstrap-table';
import connect from 'react-redux/es/connect/connect';
import CheeseburgerMenu from '../../components/menu/CheeseburgerMenu';
import TopoTitleComponente from '../../components/PageTitle/TopoTitleComponente';
import ListagemRelatorioPage from '../../components/templates/ListagemRelatoriosPage';
import TopoListagem from '../../components/Topo/TopoListagem';
import { objectsConstants } from '../../_constants/objects.constants';
import { tableHelper } from '../../_helpers/tableHelper';
import { relatorioConsultasService } from '../../_services/relatorioConsultas.service';
import { userService } from '../../_services/user.service';
import Historico from '../Historico/Historico';
import RelatoriosFilter from './RelatoriosFilter';

const columnsAnalitico = [
  {
    path: 'id',
    pathFilter: 'id',
    title: 'Código',
    isKey: true,
    dataSort: true,
    classname: 'column-center',
    width: '5%',
  },
  {
    path: 'dataConsulta',
    pathFilter: 'dataConsulta',
    title: 'Data',
    isKey: false,
    dataSort: true,
    isDate: true,
    className: 'column-bold',
    width: '6%',
  },
  {
    path: 'hora',
    pathFilter: 'hora',
    title: 'Hora',
    isKey: false,
    dataSort: true,
    className: 'column-bold column-center',
    width: '5%',
  },
  {
    path: 'pacienteNome',
    pathFilter: 'paciente',
    title: 'Paciente',
    isKey: false,
    dataSort: true,
    className: 'column-bold',
    width: '12%',
  },
  {
    path: 'tipoAtendimento',
    pathFilter: 'tipoAtendimento',
    title: 'Tipo Atendimento',
    isKey: false,
    dataSort: true,
    className: 'column-center',
    width: '8%',
  },
  {
    path: 'convenio',
    pathFilter: 'convenio',
    title: 'Convênio',
    isKey: false,
    dataSort: true,
    width: '7%',
  },
  {
    path: 'medicoNome',
    pathFilter: 'medico',
    title: 'Profissional',
    isKey: false,
    dataSort: true,
    className: 'column-bold',
    width: '12%',
  },
  {
    path: 'tipoConsulta',
    pathFilter: 'tipoConsulta',
    title: 'Tipo consulta',
    isKey: false,
    dataSort: true,
    className: '',
    width: '7%',
  },

  {
    path: 'tipo',
    pathFilter: 'tipo',
    title: 'Tipo',
    isKey: false,
    dataSort: true,
    className: '',
    width: '7%',
  },
  {
    path: 'status',
    pathFilter: 'status',
    title: 'Status',
    isKey: false,
    dataSort: true,
    isStatusMarcacao: true,
    className: 'column-bold',
    width: '7%',
  },
  {
    path: 'observacoes',
    pathFilter: 'observacoes',
    title: 'Obs:',
    isKey: false,
    dataSort: false,
    className: '',
    width: '9%',
  },
  {
    path: 'duracaoAtendimento',
    pathFilter: 'duracaoAtendimento',
    title: 'Tempo Atendimento',
    isKey: false,
    dataSort: false,
    className: 'column-bold column-center',
    width: '9%',
  },
  {
    path: 'valor',
    pathFilter: 'valor',
    title: 'Valor',
    isKey: false,
    dataSort: false,
    className: '',
    width: '6%',
  },
];

const columnsSintetico = [
  {
    path: 'count',
    pathFilter: 'count',
    title: 'Quantidade de atendimentos',
    isKey: true,
    dataSort: false,
    className: 'column-bold',
    width: '15%',
  },
  {
    path: 'medicoNome',
    pathFilter: 'medico',
    title: 'Profissional',
    isKey: false,
    dataSort: false,
    className: 'column-bold',
    width: '22%',
  },
  {
    path: 'tipoAtendimento',
    pathFilter: 'tipoAtendimento',
    title: 'Tipo do atendimento',
    isKey: false,
    dataSort: false,
  },
  {
    path: 'tipoConsulta',
    pathFilter: 'tipoConsulta',
    title: 'Tipo da consulta',
    isKey: false,
    dataSort: false,
    className: '',
  },
  {
    path: 'tipo',
    pathFilter: 'tipo',
    title: 'Tipo',
    isKey: false,
    dataSort: false,
    className: '',
  },
  {
    path: 'status',
    pathFilter: 'status',
    title: 'Status',
    isKey: false,
    dataSort: false,
    className: '',
    isStatusMarcacao: true,
  },
];
const columnsAQtdProfessional = [
  {
    path: 'count',
    pathFilter: 'count',
    title: 'Quantidade de atendimentos',
    isKey: false,
    dataSort: true,
    className: 'column-bold',
    width: '20%',
  },
  {
    path: 'medicoNome',
    pathFilter: 'medico',
    title: 'Profissional',
    isKey: true,
    dataSort: true,
    className: 'column-bold',
    width: '80%',
  },
];

type State = {
  showAnalyticData: boolean,
  showSyntheticData: boolean,
  showQtdProfessionalData: boolean,
  filter: FilterRelatorio,
};

interface FilterRelatorio {
  tipoRelatorio?: string;
  dataStart?: Date;
  dataEnd?: Date;
  listTipoAtendimento?: string[];
  listTipoConsulta?: string[];
  tipo?: string[];
  listFkMedico?: any[];
  listStatus?: string[];
  listPaciente?: any[];
}

class RelatoriosConsultasListagemPage extends React.PureComponent<{}, State> {
  constructor(props) {
    super(props);

    let fieldsAnalitico = _.map(
      _.filter(columnsAnalitico, function (coluna) {
        return !coluna.notExport;
      }),
      function (coluna) {
        return coluna.path;
      }
    );

    let labelsAnalitico = _.map(
      _.filter(columnsAnalitico, function (coluna) {
        return !coluna.notExport;
      }),
      function (coluna) {
        return coluna.title;
      }
    );

    let fieldsSintetico = _.map(
      _.filter(columnsSintetico, function (coluna) {
        return !coluna.notExport;
      }),
      function (coluna) {
        return coluna.path;
      }
    );

    let labelsSintetico = _.map(
      _.filter(columnsSintetico, function (coluna) {
        return !coluna.notExport;
      }),
      function (coluna) {
        return coluna.title;
      }
    );

    let fieldsQtdProfessional = _.map(
      _.filter(columnsAQtdProfessional, function (coluna) {
        return !coluna.notExport;
      }),
      function (coluna) {
        return coluna.path;
      }
    );

    let labelsQtdProfessional = _.map(
      _.filter(columnsAQtdProfessional, function (coluna) {
        return !coluna.notExport;
      }),
      function (coluna) {
        return coluna.title;
      }
    );
    this.state = {
      labelsAnalitico,
      fieldsAnalitico,
      labelsSintetico,
      fieldsSintetico,
      labelsQtdProfessional,
      fieldsQtdProfessional,
    };
  }

  handleRowClick = (row: e, columnIndex, rowIndex) => {
    if (userService.isAdministrador() || userService.isSuporte()) {
      this.props.receiveIdEntityHistorico(
        row.id,
        objectsConstants.TIPO_HISTORICO_MARCACAO
      );
      this.props.fechaHistorico();
      this.props.abreHistorico();
    }
  };

  loadRelatorioData = (filter: FilterRelatorio) => {
    this.setState(
      {
        showSyntheticData:
          !filter.tipoRelatorio || filter.tipoRelatorio === 'SINTETICO',
        showAnalyticData:
          filter.tipoRelatorio && filter.tipoRelatorio === 'ANALITICO',
        showQtdProfessionalData:
          filter.tipoRelatorio &&
          filter.tipoRelatorio === 'QTD_POR_PROFISSIONAL',
        filter: { ...filter },
        forceUpdateKey: Date.now(),
      },
      () => {
      }
    );
  };

  render() {
    const tableColumn = _.map(
      this.state.showAnalyticData
        ? columnsAnalitico
        : this.state.showSyntheticData
          ? columnsSintetico
          : columnsAQtdProfessional,
      (column, index) => (
        <TableHeaderColumn
          key={index}
          dataField={column.path}
          dataFormat={tableHelper.renderCustom}
          formatExtraData={column}
          isKey={column.isKey}
          dataSort={column.dataSort}
          hidden={column.hidden}
          width={column.width}
          className={column.classname}
        >
          {column.title}
        </TableHeaderColumn>
      )
    );

    return (
      <React.Fragment>
        <TopoTitleComponente
          mainTitle={objectsConstants.TITULO_PAGINA_RELATORIOS_CONSULTA}
          subTitle=" "
          canBack={false}
        />

        <TopoListagem
          securityActionDo={objectsConstants.VIEW}
          securityActionOn={objectsConstants.MENU_RELATORIOS}
          buttonAction={() => { }}
          securityActionIcon={''}
          securityActionName={''}
        ></TopoListagem>
        <RelatoriosFilter submitFilter={this.loadRelatorioData} />
        <ListagemRelatorioPage
          key={this.state.forceUpdateKey}
          title={
            this.state.showAnalyticData
              ? 'Listagem de consultas Analítico'
              : this.state.showSyntheticData
                ? 'Listagem de consultas Sintético'
                : 'Listagem quantidade por profissional'
          }
          service={relatorioConsultasService}
          controller="/api/relatorio/consultas"
          defaultOrder={
            this.state.showQtdProfessionalData ? 'count' : 'dataConsulta'
          }
          defaultDirection={'desc'}
          filtro={this.state.filter}
          onRowClick={this.state.showAnalyticData ? this.handleRowClick : null}
          fields={
            this.state.showAnalyticData
              ? this.state.fieldsAnalitico
              : this.state.showSyntheticData
                ? this.state.fieldsSintetico
                : this.state.fieldsQtdProfessional
          }
          labels={
            this.state.showAnalyticData
              ? this.state.labelsAnalitico
              : this.state.showSyntheticData
                ? this.state.labelsSintetico
                : this.state.labelsQtdProfessional
          }
          columns={
            this.state.showAnalyticData
              ? columnsAnalitico
              : this.state.showSyntheticData
                ? columnsSintetico
                : columnsAQtdProfessional
          }
          selectRow={{ bgColor: 'red' }}
        >
          {tableColumn}
        </ListagemRelatorioPage>

        <CheeseburgerMenu
          isOpen={this.props.historicoAberto}
          closeCallback={this.props.fechaHistorico}
          right={true}
          width={400}
          className="historico-bg"
        >
          {this.props.historicoAberto && (
            <Historico idEntity={this.props.idEntityHistorico} />
          )}
        </CheeseburgerMenu>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  const { historicoAberto, idEntityHistorico } = state.historicomenu;
  return {
    user,
    historicoAberto,
    idEntityHistorico,
  };
}

const mapDispatch = ({
  historicomenu: {
    toggleHistorico,
    abreHistorico,
    fechaHistorico,
    receiveIdEntityHistorico,
  },
}) => ({
  toggleHistorico: () => toggleHistorico(),
  abreHistorico: () => abreHistorico({}),
  receiveIdEntityHistorico: (idEntityHistorico, tipoHistorico) =>
    receiveIdEntityHistorico({ idEntityHistorico, tipoHistorico }),
  fechaHistorico: () => fechaHistorico(),
});

export default connect(
  mapStateToProps,
  mapDispatch
)(RelatoriosConsultasListagemPage);
